/**
 * @Author: wuyang
 * @Date: 2023/12/20
 * @Description: ""
 */
import React, { useEffect, useMemo } from 'react'
import {
	Navigate,
	UIMatch,
	useLocation,
	useMatches,
	useNavigate,
	useOutlet
} from 'react-router-dom'
import { FullScreen } from '@/layout/full-screen/FullScreen'
import { userinfoService } from '@/common/services/userinfo/userinfoService'
import { eventBusService } from '@/common/services/event-bus/eventBusService'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { message } from 'antd'
import { useUpdateEffect } from 'ahooks'

interface IHandleProps {
	isFull: boolean
	isAuth: boolean
	title: string
}

const defaultHandle: IHandleProps = {
	isAuth: true,
	isFull: false,
	title: '小AI商创'
}

export function BaseLayout(props: any) {
	const [messageApi, contextHolder] = message.useMessage()
	const navigate = useNavigate()
	const location = useLocation()

	// 此处监听登录信息相关的跳转逻辑
	const matches = useMatches() as UIMatch<any, IHandleProps>[]
	const outlet = useOutlet()

	// 加载用户态
	const [token] = useAtomMethod(userinfoService.token)
	const [userInfo] = useAtomMethod(userinfoService.userInfo)

	// 加载全局事件监听机制
	eventBusService.ready()

	// 如果 token 发生变化，重新请求 userinfo
	useUpdateEffect(() => {
		userinfoService.refresh().then((res) => {
			// 禁用用户扫码提示
			if (res && res.data && res.data.code === 500 && res.data.msg) {
				messageApi.warning(res.data.msg)
			}
		})
	}, [token])

	useEffect(() => {
		const layoutMatches = matches?.[1] ?? {}
		const { handle, pathname } = layoutMatches
		const { isAuth } = Object.assign({}, defaultHandle, handle)
		
		if (userinfoService.isLogin.get() && userinfoService.token.get()) {
			if (pathname.endsWith('/login')) {
				userinfoService.login()
				// if (
				// 	!userinfoService.skipScan.get() &&
				// 	userInfo?.phone &&
				// 	!userInfo?.wxOpenId
				// ) {
				// 	navigate('/login-continue?type=qrcode')
				// } else {
				// 	navigate('/')
				// }  // 公众号现在未运营，暂时拿掉跳转公众号
				navigate('/')
			}
			return
		}
		// 如果是未登录状态则跳转到登录
		if (isAuth || pathname.startsWith('/login')) {
			/**
			 * 1. 如果 手机号登录成功跳到微信扫码页
			 * 2. 微信扫码页跳过跳到首页
			 */

			if (userInfo?.phone) {
				if (pathname.endsWith('/login')) {
					userinfoService.login()
					// if (
					// 	!userinfoService.skipScan.get() &&
					// 	userInfo?.phone &&
					// 	!userInfo?.wxOpenId
					// ) {
					// 	navigate('/login-continue?type=qrcode')
					// } else {
					// 	navigate('/')
					// }  // 公众号现在未运营，暂时拿掉跳转公众号
					navigate('/')
				}
			} else {
				let goUrlStr = '/login'
				// if (userInfo?.wxOpenId) {
				// 	goUrlStr = '/login-continue?type=number'
				// } else if (userInfo?.phone) {
				// 	goUrlStr = '/login-continue?type=qrcode'
				// }

				if (goUrlStr !== location.pathname + location.search) {
					if (goUrlStr === '/login') {
						window.location.href = goUrlStr
					} else {
						navigate(goUrlStr)
					}
				}
			}
		}
	}, [location, matches, navigate, userInfo])

	const page = useMemo(() => {
		const layoutMatches = matches?.[1] ?? {}

		const { handle, pathname } = layoutMatches

		const { isFull } = Object.assign({}, defaultHandle, handle)

		// 如果是 全屏则进入全屏页面
		if (isFull) {
			return <FullScreen>{outlet}</FullScreen>
		} else {
			// 根据 layout 进入对应的路由
			if (pathname.startsWith('/workspace')) {
				// 当只有二级路由时，重定向到下一级
				if (matches.length < 3) {
					return <Navigate to="mannequin" replace />
				}
			}
			return <>{outlet}</>
		}
	}, [matches, outlet])

	useEffect(() => {
		const title = (matches[1].handle as any)?.title
		const isHasTitle = typeof title === 'string'
		if (isHasTitle) {
			document.title = title
		}
	}, [matches])

	return (
		<>
			{contextHolder}
			{page}
		</>
	)
}
